import { render, staticRenderFns } from "./MyCompanyReportsArticles.vue?vue&type=template&id=6bd2363e&scoped=true&"
import script from "./MyCompanyReportsArticles.vue?vue&type=script&lang=js&"
export * from "./MyCompanyReportsArticles.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyReportsArticles.vue?vue&type=style&index=0&id=6bd2363e&lang=scss&scoped=true&"
import style1 from "./MyCompanyReportsArticles.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2363e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VRadio,VRadioGroup,VRow,VSelect})
